import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-019cdcbc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "about-us--carousel",
  class: "carousel slide"
}
const _hoisted_2 = { class: "carousel-inner" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "carousel-control-prev-icon",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Föregående", -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "carousel-control-next-icon",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Nästa", -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]

import { onMounted, ref, watch, nextTick } from 'vue';
    import { fileApi } from '@/services/file.service';
    import { FileItem } from '@/types/FileItem';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'Video',
  setup(__props) {

    const files = ref<FileItem[]>([]);
    const activeIndex = ref(0);
    const videoRefs = ref<Array<HTMLVideoElement | null>>([]);

    onMounted(async () => {
        const res = await fileApi.getAll(2, 0);
        files.value = res;
    });

    function playNextVideo() {
        activeIndex.value = (activeIndex.value + 1) % files.value.length;
    }

    function goToNextSlide() {
        activeIndex.value = (activeIndex.value + 1) % files.value.length;
    }

    function goToPreviousSlide() {
        activeIndex.value = (activeIndex.value - 1 + files.value.length) % files.value.length;
    }

    function getComponentName(index: number): string {
        return index === activeIndex.value ? 'video-component' : 'placeholder-component';
    }

    function getFileSource(file: FileItem): string {
        return `/images/${file.name}`;
    }

    function getVideoRef(index: number): string {
        return `videoRef-${index}`;
    }

    // Lyssna på förändringar av activeIndex och spela upp nästa video automatiskt
    watch(activeIndex, async (newValue, oldValue) => {
        const oldVideoRef = videoRefs.value[oldValue];
        if (oldVideoRef) {
            oldVideoRef.pause();
            oldVideoRef.currentTime = 0;
        }

        await nextTick(); // Vänta tills DOM-uppdatering är klar

        const newVideoRef = videoRefs.value[newValue];
        if (newVideoRef) {
            newVideoRef.play();
        }
    });

return (_ctx: any,_cache: any) => {
  return (files.value.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(getComponentName(activeIndex.value)), { key: activeIndex.value }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(files.value, (file, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass({ 'carousel-item': true, 'active': index === activeIndex.value })
                }, [
                  (index === activeIndex.value)
                    ? (_openBlock(), _createElementBlock("video", {
                        key: 0,
                        ref_for: true,
                        ref: getVideoRef(index),
                        class: "card-img-top mb-5 mb-md-0 rounded big-image",
                        autoplay: "",
                        muted: "",
                        controls: "",
                        onEnded: playNextVideo,
                        prefix: "none"
                      }, [
                        _createElementVNode("source", {
                          src: getFileSource(file),
                          type: "video/mp4"
                        }, null, 8, _hoisted_3)
                      ], 544))
                    : (_openBlock(), _createElementBlock("div", _hoisted_4))
                ], 2))
              }), 128))
            ]),
            _: 1
          }))
        ]),
        _createElementVNode("div", { class: "d-flex justify-content-between" }, [
          _createElementVNode("button", {
            class: "carousel-control-prev",
            onClick: goToPreviousSlide
          }, _hoisted_7),
          _createElementVNode("button", {
            class: "carousel-control-next",
            onClick: goToNextSlide
          }, _hoisted_10)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})